import css from './ListingPage.module.css';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import React from 'react';
import { useDispatch } from 'react-redux';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { handleToggleFavourites } from '../../containers/ListingPage/ListingPage.shared';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { useHistory, useLocation } from 'react-router-dom';

const FavouriteButton = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const routeConfiguration = useRouteConfiguration();

  const { currentUser, currentListingId } = props;
  const isFavourite = currentUser?.attributes.profile.privateData.favourites?.includes(
    currentListingId
  );
  const onUpdateFavourites = payload => dispatch(updateProfile(payload));

  const toggleFavourites = () =>
    handleToggleFavourites({
      ...props,
      currentUser,
      onUpdateFavourites,
      history,
      location,
      routes: routeConfiguration,
      isFavourite,
      params: { id: currentListingId },
    });

  return (
    <button className={css.icon} onClick={toggleFavourites}>
      {isFavourite ? (
        <span>
          <FavoriteRoundedIcon />
          <span className={css.iconLabel}>Unsave</span>
        </span>
      ) : (
        <span>
          <FavoriteBorderRoundedIcon />
          <span className={css.iconLabel}>Save</span>
        </span>
      )}
    </button>
  );
};

export default FavouriteButton;
